import React from "react";
import useQualarooController from "./controller";
import { createFunctionalComponentFromView } from "../../common/utils/view-controller";

const Qualaroo = createFunctionalComponentFromView(
  useQualarooController,
  (controller) => <div id="qualaroo-nudge" />,
);

export default Qualaroo;
